/* PTB Atelier — noyau de l'assistant : état, navigation, étape 1 (articles), étape 2 (taille / couleur / quantité), récapitulatif latéral, estimation.
   Chaque ligne (un article, une taille, une couleur, une quantité) porte SA propre personnalisation (line.d) ; l'option « même
   personnalisation pour tous les articles » recopie celle du premier article sur les autres (voir A.syncSame). */
(function () {
  'use strict';
  var C = window.PTB_ATELIER_CFG;
  var A = (window.PTBAtelier = window.PTBAtelier || {});
  var root = document.getElementById('ptb-atelier-app');
  if (!C || !root || !A.data || !A.t) return;

  var T = A.t, money = A.util.money;
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  function esc(s) { return String(s === undefined || s === null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function uid() { return 'l' + Math.random().toString(36).slice(2, 9); }
  function imgUrl(u, w) { return u ? u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w : ''; }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  A.util.esc = esc; A.util.imgUrl = imgUrl; A.util.debounce = debounce; A.util.$ = $; A.util.$$ = $$; A.util.uid = uid;

  var STEPS = 5;
  var CATS = ['tshirt', 'polo', 'sweat', 'headwear', 'bag', 'baby', 'other'];
  var STORE_KEY = 'ptb_atelier_v3';

  /* ---------- état ---------- */
  var S = A.state = {
    step: 1, maxStep: 1, cat: 'all',
    lines: [],          /* { uid, handle, color, size, qty, d } — d = personnalisation de CET article */
    same: true,         /* true : la personnalisation du premier article est appliquée à tous */
    tab: 0,             /* article affiché aux étapes 3 et 4 quand same = false */
    contact: { first: '', last: '', email: '', phone: '', message: '', country: C.country },
    consent: false,
    est: { status: 'idle', data: null }
  };
  A.images = {};        /* id -> { name, type, size, width, height, dataUrl } — jamais persisté si volumineux */
  A.products = {};      /* handle -> détail Shopify (variantes) */
  A.catalog = [];       /* articles personnalisables */
  A.steps = {};
  var catalogState = 'loading';

  function productByHandle(h) { for (var i = 0; i < A.catalog.length; i++) if (A.catalog[i].handle === h) return A.catalog[i]; return null; }
  A.productByHandle = productByHandle;

  /* ---------- personnalisation d'un article ---------- */
  var DEFAULT_FONT = (C.fonts[0] && C.fonts[0].id) || 'anton';
  A.newDesign = function (src) {
    var d = { type: null, text: '', font: DEFAULT_FONT, instr: '', place: null, threads: [], img: null, size: { mode: 'auto', w: '', h: '' } };
    /* l'emplacement et la taille restent propres à chaque article : ils ne sont pas recopiés */
    if (src) { d.type = src.type; d.text = src.text; d.font = src.font; d.instr = src.instr; d.threads = (src.threads || []).slice(); d.img = src.img; }
    return d;
  };
  /* ---------- taille de la broderie ----------
     « Carte blanche » (mode auto) : l'atelier choisit la taille pour le meilleur rendu ; sinon largeur × hauteur en cm (mode custom). */
  var SIZE_MIN = (C.limits && C.limits.sizeMinCm) || 1, SIZE_MAX = (C.limits && C.limits.sizeMaxCm) || 40;
  A.sizeLimits = { min: SIZE_MIN, max: SIZE_MAX };
  A.normSize = function (s) {
    s = s && typeof s === 'object' ? s : {};
    return { mode: s.mode === 'custom' ? 'custom' : 'auto', w: String(s.w === undefined || s.w === null ? '' : s.w).slice(0, 6), h: String(s.h === undefined || s.h === null ? '' : s.h).slice(0, 6) };
  };
  A.parseCm = function (v) {
    var s = String(v === undefined || v === null ? '' : v).trim().replace(',', '.');
    if (!/^\d{1,3}(\.\d{1,2})?$/.test(s)) return null;
    var n = Math.round(parseFloat(s) * 10) / 10;
    return n > 0 ? n : null;
  };
  A.fmtCm = function (n) { var s = String(Math.round(n * 10) / 10); return /^(fr|es|de|it|nl)$/.test(C.lang) ? s.replace('.', ',') : s; };
  /* état de la taille d'un article : { mode:'auto', ok:true } ou { mode:'custom', ok, w, h, err:'both'|'range' } */
  A.sizeState = function (d) {
    var s = A.normSize(d && d.size);
    if (s.mode !== 'custom') return { mode: 'auto', ok: true };
    var w = A.parseCm(s.w), h = A.parseCm(s.h);
    if (!w || !h) return { mode: 'custom', ok: false, w: w, h: h, err: 'both' };
    if (w < SIZE_MIN || h < SIZE_MIN || w > SIZE_MAX || h > SIZE_MAX) return { mode: 'custom', ok: false, w: w, h: h, err: 'range' };
    return { mode: 'custom', ok: true, w: w, h: h };
  };
  A.sizeText = function (d, long) {
    var st = A.sizeState(d);
    if (st.mode === 'custom' && st.ok) return T(long ? 'size.fmtLong' : 'size.fmt', { w: A.fmtCm(st.w), h: A.fmtCm(st.h) });
    return T(long ? 'size.autoLong' : 'size.autoShort');
  };
  /* emplacements possibles selon la silhouette de l'article */
  A.placementsFor = function (sub) {
    if (sub === 'top') return [['chest_left', 'pl.chest_left'], ['chest_right', 'pl.chest_right'], ['chest_center', 'pl.chest_center'], ['back', 'pl.back'], ['sleeve_left', 'pl.sleeve_left'], ['sleeve_right', 'pl.sleeve_right']];
    if (sub === 'cap') return [['front', 'pl.front'], ['side_left', 'pl.side_left'], ['side_right', 'pl.side_right'], ['back', 'pl.back_cap']];
    if (sub === 'beanie' || sub === 'bag') return [['front', 'pl.front']];
    return [['front', 'pl.front'], ['custom', 'pl.custom']];
  };
  function defaultPlacement(handle) { var p = productByHandle(handle); return p && p.sub === 'top' ? 'chest_center' : 'front'; }
  function fixPlacement(line) {
    var p = productByHandle(line.handle), allowed = A.placementsFor(p ? p.sub : 'other').map(function (x) { return x[0]; });
    if (allowed.indexOf(line.d.place) < 0) line.d.place = defaultPlacement(line.handle);
  }
  A.fixPlacements = function () { S.lines.forEach(fixPlacement); };

  A.activeLine = function () { return S.same ? S.lines[0] : (S.lines[Math.min(S.tab, S.lines.length - 1)] || S.lines[0]); };
  A.targets = function () { return S.same ? S.lines.slice() : [A.activeLine()].filter(Boolean); };
  /* même personnalisation pour tous : on recopie celle du premier article (l'emplacement reste propre à chaque article) */
  A.syncSame = function () {
    if (!S.same || S.lines.length < 2) return;
    var m = S.lines[0].d;
    S.lines.forEach(function (l, i) {
      if (!i) return;
      l.d.type = m.type; l.d.text = m.text; l.d.font = m.font; l.d.instr = m.instr; l.d.threads = m.threads.slice(); l.d.img = m.img;
    });
  };
  A.designsDiffer = function () {
    var m = S.lines[0] && S.lines[0].d;
    return !!m && S.lines.some(function (l, i) {
      return i > 0 && (l.d.type !== m.type || l.d.text !== m.text || l.d.font !== m.font || l.d.instr !== m.instr || l.d.img !== m.img || l.d.threads.join(',') !== m.threads.join(','));
    });
  };
  A.copyDesign = function (fromUid, toUid) {
    var from = lineByUid(fromUid), to = lineByUid(toUid);
    if (!from || !to || from === to) return;
    var place = to.d.place, size = A.normSize(to.d.size);
    to.d = A.newDesign(from.d); to.d.place = place; to.d.size = size;
    fixPlacement(to);
  };
  /* retire les images qu'aucun article n'utilise plus */
  A.gcImages = function () {
    var used = {};
    S.lines.forEach(function (l) { if (l.d.img) used[l.d.img] = 1; });
    Object.keys(A.images).forEach(function (k) { if (!used[k]) delete A.images[k]; });
  };
  function clampTab() { if (S.tab >= S.lines.length) S.tab = Math.max(0, S.lines.length - 1); }

  /* ---------- persistance temporaire (onglet uniquement, effacée à l'envoi) ---------- */
  function persist() {
    try {
      var copy = JSON.parse(JSON.stringify({ step: S.step, maxStep: S.maxStep, lines: S.lines, same: S.same, tab: S.tab, contact: S.contact, ts: Date.now() }));
      sessionStorage.setItem(STORE_KEY, JSON.stringify(copy));
      var imgs = JSON.stringify(A.images);
      if (Object.keys(A.images).length && imgs.length < 2500000) sessionStorage.setItem(STORE_KEY + '_img', imgs);
      else sessionStorage.removeItem(STORE_KEY + '_img');
    } catch (e) { /* stockage indisponible : on continue sans */ }
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return false;
      var d = JSON.parse(raw);
      if (!d || Date.now() - d.ts > 2 * 3600 * 1000 || !d.lines || !d.lines.length) return false;
      S.lines = d.lines.map(function (l) { l.d = Object.assign(A.newDesign(), l.d || {}); l.d.threads = (l.d.threads || []).slice(0, C.limits.maxThreads); l.d.size = A.normSize(l.d.size); return l; });
      S.same = d.same !== false; S.tab = d.tab || 0;
      S.contact = Object.assign(S.contact, d.contact || {});
      S.step = Math.min(d.step || 1, STEPS); S.maxStep = Math.min(d.maxStep || 1, STEPS);
      var im = sessionStorage.getItem(STORE_KEY + '_img');
      if (im) A.images = JSON.parse(im) || {};
      S.lines.forEach(function (l) { if (l.d.img && !A.images[l.d.img]) { l.d.img = null; if (l.d.type === 'image') l.d.type = null; } });
      clampTab();
      return true;
    } catch (e) { return false; }
  }
  A.clearStored = function () { try { sessionStorage.removeItem(STORE_KEY); sessionStorage.removeItem(STORE_KEY + '_img'); } catch (e) { /* rien */ } };

  /* ---------- variantes ---------- */
  function pickVariant(d, color, size) {
    if (!d) return null;
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      if (d.colorIdx >= 0 && v.options[d.colorIdx] !== color) continue;
      if (d.sizeIdx >= 0 && v.options[d.sizeIdx] !== size) continue;
      return v;
    }
    return null;
  }
  function colorEnabled(d, line, value) {
    return d.variants.some(function (v) { return v.available && v.options[d.colorIdx] === value && (d.sizeIdx < 0 || !line.size || v.options[d.sizeIdx] === line.size); });
  }
  function sizeEnabled(d, line, value) {
    return d.variants.some(function (v) { return v.available && v.options[d.sizeIdx] === value && (d.colorIdx < 0 || !line.color || v.options[d.colorIdx] === line.color); });
  }
  /* après un changement : si l'autre option n'est plus disponible, on la remet à choisir */
  function normalizeLine(line) {
    var d = A.products[line.handle];
    if (!d) return;
    if (d.colorIdx >= 0) {
      if (d.colors.length === 1) line.color = d.colors[0].value;
      if (line.color && !d.colors.some(function (c) { return c.value === line.color; })) line.color = null;
    }
    if (d.sizeIdx >= 0) {
      if (d.sizes.length === 1) line.size = d.sizes[0].value;
      if (line.size && !d.sizes.some(function (s) { return s.value === line.size; })) line.size = null;
      if (line.size && d.colorIdx >= 0 && line.color && !sizeEnabled(d, line, line.size)) line.size = null;
    }
    if (d.colorIdx >= 0 && line.color && d.sizeIdx >= 0 && line.size && !colorEnabled(d, line, line.color)) line.color = null;
  }
  function lineInfo(line) {
    var d = A.products[line.handle], p = productByHandle(line.handle);
    var v = d ? pickVariant(d, line.color, line.size) : null;
    var unit = v ? v.price : 0;
    var cur = v ? v.currency : (p ? p.currency : C.currency);
    var colorLabel = '', sizeLabel = '';
    if (d && d.colorIdx >= 0 && line.color) { var cc = d.colors.filter(function (c) { return c.value === line.color; })[0]; colorLabel = cc ? cc.label : line.color; }
    if (d && d.sizeIdx >= 0 && line.size) { var ss = d.sizes.filter(function (s) { return s.value === line.size; })[0]; sizeLabel = ss ? ss.label : line.size; }
    var colorImg = '';
    if (d && d.colorIdx >= 0 && line.color) { var ci = d.colors.filter(function (c) { return c.value === line.color; })[0]; colorImg = (ci && ci.image && ci.image.url) || ''; }
    return {
      line: line, n: S.lines.indexOf(line) + 1, detail: d, product: p, variant: v, complete: !!(v && v.available), unit: unit, qty: line.qty, total: unit * line.qty, currency: cur,
      title: d ? d.title : (p ? p.title : line.handle), colorLabel: colorLabel, sizeLabel: sizeLabel,
      image: (v && v.image && v.image.url) || colorImg || (p && p.image) || ''
    };
  }
  A.lineInfo = lineInfo;
  A.infos = function () { return S.lines.map(lineInfo); };
  function completeInfos() { return A.infos().filter(function (i) { return i.complete; }); }
  function groups() {
    var order = [], map = {};
    S.lines.forEach(function (l) { if (!map[l.handle]) { map[l.handle] = []; order.push(l.handle); } map[l.handle].push(l); });
    return order.map(function (h) { return { handle: h, lines: map[h] }; });
  }
  A.groups = groups;
  function lineByUid(u) { for (var i = 0; i < S.lines.length; i++) if (S.lines[i].uid === u) return S.lines[i]; return null; }
  A.lineByUid = lineByUid;
  /* intitulé court d'un article : « Article 2 — T-shirt classique · Noir · M » */
  A.lineLabel = function (info) {
    var meta = [info.colorLabel, info.sizeLabel].filter(Boolean).join(' · ');
    return T('line.n', { n: info.n }) + ' — ' + info.title + (meta ? ' · ' + meta : '');
  };

  /* ---------- ajout / retrait ---------- */
  function blankLine(handle) {
    var l = { uid: uid(), handle: handle, color: null, size: null, qty: 1, d: A.newDesign(S.same && S.lines.length ? S.lines[0].d : null) };
    l.d.place = null; fixPlacement(l);
    return l;
  }
  function addProduct(handle, preVariantId) {
    var p = productByHandle(handle);
    if (!p) return Promise.resolve(false);
    return A.data.fetchProduct(handle, p).then(function (d) {
      A.products[handle] = d;
      var line = blankLine(handle);
      var pre = preVariantId ? d.variants.filter(function (v) { return (v.id === String(preVariantId) || v.refId === String(preVariantId)) && v.available; })[0] : null;
      if (pre) {
        if (d.colorIdx >= 0) line.color = pre.options[d.colorIdx];
        if (d.sizeIdx >= 0) line.size = pre.options[d.sizeIdx];
      } else if (d.colorIdx >= 0) {
        /* coloris proposé d'office : blanc ou noir s'ils existent (le plus lisible pour l'aperçu), sinon le premier disponible */
        var ok = d.colors.filter(function (c) { return colorEnabled(d, line, c.value); }), pref = null;
        ['white', 'blanc', 'black', 'noir'].some(function (w) { pref = ok.filter(function (c) { return A.util.norm(c.fr) === w; })[0] || null; return !!pref; });
        line.color = pref ? pref.value : (ok[0] ? ok[0].value : null);
      }
      normalizeLine(line);
      S.lines.push(line);
      return true;
    });
  }
  function removeProduct(handle) {
    S.lines = S.lines.filter(function (l) { return l.handle !== handle; });
    clampTab(); A.gcImages();
  }
  function ensureProducts() {
    var need = [];
    S.lines.forEach(function (l) { if (!A.products[l.handle] && need.indexOf(l.handle) < 0) need.push(l.handle); });
    return Promise.all(need.map(function (h) {
      var p = productByHandle(h);
      if (!p) { removeProduct(h); return null; }
      return A.data.fetchProduct(h, p).then(function (d) { A.products[h] = d; }).catch(function () { removeProduct(h); });
    })).then(function () { S.lines.forEach(function (l) { normalizeLine(l); fixPlacement(l); }); });
  }

  /* ---------- notice ---------- */
  A.notice = function (msg, kind) {
    var n = $('[data-role="notice"]');
    if (!n) return;
    if (!msg) { n.hidden = true; n.innerHTML = ''; return; }
    n.hidden = false;
    n.className = 'atl-notice' + (kind ? ' atl-notice--' + kind : '');
    n.innerHTML = '<span>' + esc(msg) + '</span><button type="button" class="atl-notice__x" data-action="notice-close" aria-label="' + esc(T('common.close')) + '">×</button>';
  };

  /* ---------- coque ---------- */
  function shell() {
    root.innerHTML =
      '<div class="atl-notice" data-role="notice" role="status" aria-live="polite" hidden></div>' +
      '<nav class="atl-progress" aria-label="' + esc(T('progress.label')) + '"><ol data-role="progress"></ol><p class="atl-progress__now" data-role="progress-now"></p></nav>' +
      '<div class="atl-layout">' +
        '<div class="atl-main">' +
          '<div class="atl-step" data-role="step" tabindex="-1"></div>' +
          '<div class="atl-nav" data-role="nav"></div>' +
        '</div>' +
        '<aside class="atl-side" aria-label="' + esc(T('summary.title')) + '">' +
          '<details class="atl-sum" data-role="sum"><summary class="atl-sum__sum"><span class="atl-sum__head"><span class="atl-sum__title">' + esc(T('summary.title')) + '</span><span class="atl-sum__badge" data-role="sum-badge"></span></span></summary>' +
          '<div class="atl-sum__body" data-role="sum-body"></div></details>' +
          '<div class="atl-side__cta" data-role="side-cta"></div>' +
        '</aside>' +
      '</div>';
    var det = $('[data-role="sum"]');
    if (det && window.matchMedia && window.matchMedia('(min-width: 960px)').matches) det.open = true;
  }

  function renderProgress() {
    var ol = $('[data-role="progress"]');
    if (!ol) return;
    var html = '';
    for (var i = 1; i <= STEPS; i++) {
      var cls = 'atl-progress__item' + (i === S.step ? ' is-current' : '') + (i < S.step || i <= S.maxStep && i !== S.step ? ' is-done' : '');
      var can = i <= S.maxStep && i !== S.step;
      html += '<li class="' + cls + '"' + (i === S.step ? ' aria-current="step"' : '') + '>' +
        (can ? '<button type="button" class="atl-progress__btn" data-action="goto" data-step="' + i + '">' : '<span class="atl-progress__btn">') +
        '<span class="atl-progress__n">' + (i < S.step ? '✓' : i) + '</span><span class="atl-progress__l">' + esc(T('step.' + i)) + '</span>' +
        (can ? '</button>' : '</span>') + '</li>';
    }
    ol.innerHTML = html;
    var now = $('[data-role="progress-now"]');
    if (now) now.textContent = T('progress.step', { n: S.step, total: STEPS }) + ' — ' + T('step.' + S.step);
  }

  function renderNav(err) {
    var nav = $('[data-role="nav"]');
    if (!nav) return;
    var last = S.step === STEPS;
    nav.innerHTML =
      '<p class="atl-nav__err" data-role="nav-err" role="alert">' + (err ? esc(err) : '') + '</p>' +
      '<div class="atl-nav__btns">' +
        (S.step > 1 ? '<button type="button" class="btn btn--outline" data-action="back">' + esc(T('common.back')) + '</button>' : '<span></span>') +
        (last ? '' : '<button type="button" class="btn btn--gold" data-action="next">' + esc(T('common.next')) + '</button>') +
      '</div>';
  }
  A.setNavError = function (msg) {
    var e = $('[data-role="nav-err"]'); if (e) e.textContent = msg || '';
    var s2 = $('[data-role="sum-err"]'); if (s2) s2.textContent = msg || '';
  };

  /* bouton « Continuer » sous la demande : toujours visible (colonne collante sur ordinateur, barre du haut sur mobile) */
  function renderSideCta() {
    var host = $('[data-role="side-cta"]');
    if (!host) return;
    var last = S.step === STEPS;
    host.innerHTML = '<button type="button" class="btn btn--gold atl-side__btn" data-action="' + (last ? 'send' : 'next') + '">' +
      (last ? '<span class="atl-lbl-long">' + esc(T('step5.send')) + '</span><span class="atl-lbl-short">' + esc(T('step5.sendShort')) + '</span>' : esc(T('common.next'))) +
      '</button><p class="atl-side__err" data-role="sum-err" role="alert"></p>';
  }
  A.hideNav = function (hide) { var n = $('[data-role="nav"]'); if (n) n.hidden = !!hide; };

  /* ---------- prix / estimation ---------- */
  var estCache = {}, estSeq = 0;
  function refreshPrices() {
    renderSummary();
    if (A.steps[S.step] && A.steps[S.step].updatePrice) A.steps[S.step].updatePrice();
  }
  var runEstimate = debounce(function () {
    var items = {};
    completeInfos().forEach(function (i) { items[i.variant.gid] = (items[i.variant.gid] || 0) + i.qty; });
    var arr = Object.keys(items).map(function (g) { return { gid: g, qty: items[g] }; });
    if (!arr.length) { S.est = { status: 'idle', data: null }; refreshPrices(); return; }
    var key = JSON.stringify(arr) + '|' + C.country;
    /* une même combinaison n'est calculée qu'une fois (chaque calcul crée un panier Storefront anonyme et jetable) */
    if (estCache[key]) { estSeq++; S.est = { status: 'ok', data: estCache[key] }; refreshPrices(); return; }
    S.est = { status: 'loading', data: S.est.data };
    refreshPrices();
    var seq = ++estSeq;
    A.data.estimate(arr, C.country).then(function (d) {
      estCache[key] = d;
      if (seq === estSeq) S.est = { status: 'ok', data: d };
    }).catch(function () {
      if (seq === estSeq) S.est = { status: 'error', data: null };
    }).then(function () { if (seq === estSeq) refreshPrices(); });
  }, 450);
  /* l'indicateur « calcul… » apparaît tout de suite ; la requête part après une courte pause (saisies rapides) */
  var scheduleEstimate = function () {
    if (completeInfos().length && S.est.status !== 'loading') { S.est = { status: 'loading', data: S.est.data }; refreshPrices(); }
    runEstimate();
  };
  A.scheduleEstimate = scheduleEstimate;

  function localSubtotal() {
    var infos = completeInfos(), sum = 0, cur = C.currency;
    infos.forEach(function (i) { sum += i.total; cur = i.currency; });
    return { sum: sum, cur: cur, count: infos.reduce(function (n, i) { return n + i.qty; }, 0) };
  }
  A.localSubtotal = localSubtotal;

  /* bloc prix : sous-total (prix du site), livraison estimée, total estimé + indication « livraison offerte ».
     Les articles personnalisés n'ont jamais de remise de pack : la ligne « Remise » n'apparaît que si la boutique en applique une. */
  A.priceHtml = function () {
    var ls = localSubtotal();
    if (!ls.count) return '<p class="atl-muted">' + esc(T('summary.empty')) + '</p>';
    var e = S.est, d = e.data, cur = d ? d.currency : ls.cur;
    var rows = '';
    var before = d ? d.before : ls.sum;
    rows += '<div class="atl-price__row"><span>' + esc(T('price.subtotal')) + '</span><b>' + esc(money(before, cur)) + '</b></div>';
    if (d && d.discount > 0.005) {
      rows += '<div class="atl-price__row atl-price__row--disc"><span>' + esc(T('price.discount')) + (d.discountTitles.length ? ' <small>(' + esc(d.discountTitles.join(', ')) + ')</small>' : '') + '</span><b>−' + esc(money(d.discount, cur)) + '</b></div>';
    }
    var ship;
    if (e.status === 'loading' && !d) ship = '<em>' + esc(T('price.calc')) + '</em>';
    else if (!d) ship = '<em>' + esc(T('price.toConfirm')) + '</em>';
    else if (d.freeShip) ship = '<b class="atl-price__free">' + esc(T('price.free')) + '</b>';
    else if (d.shipping === null) ship = '<em>' + esc(T('price.toConfirm')) + '</em>';
    else ship = '<b>' + esc(money(d.shipping, cur)) + '</b>';
    rows += '<div class="atl-price__row"><span>' + esc(T('price.shipping')) + '</span>' + ship + '</div>';
    var tot = d && d.total !== null ? '<b>' + esc(money(d.total, cur)) + '</b>' : '<em>' + esc(T('price.toConfirm')) + '</em>';
    rows += '<div class="atl-price__row atl-price__row--total"><span>' + esc(T('price.total')) + '</span>' + tot + '</div>';
    /* indication livraison offerte, cohérente avec la règle boutique (seuil évalué après réductions) */
    var hint = '';
    if (d) {
      if (d.freeShip) hint = '<p class="atl-free is-ok"><span aria-hidden="true">✓</span> ' + esc(T('price.freeShipping')) + '</p>';
      else if (cur === 'EUR') {
        var rem = C.limits.freeShipping - d.after;
        var pct = Math.min(100, Math.max(0, Math.round(d.after / C.limits.freeShipping * 100)));
        if (rem > 0.004) hint = '<div class="atl-free"><p>' + esc(T('price.remaining', { amount: money(rem, cur) })) + '</p><div class="atl-free__bar" aria-hidden="true"><i style="width:' + pct + '%"></i></div></div>';
      } else hint = '<p class="atl-free">' + esc(T('price.thresholdOther', { amount: C.limits.freeShipping + ' €' })) + '</p>';
    }
    var err = e.status === 'error' ? '<p class="atl-muted atl-price__err">' + esc(T('price.unavailable')) + '</p>' : '';
    return '<div class="atl-price' + (e.status === 'loading' ? ' is-loading' : '') + '" aria-live="polite" aria-busy="' + (e.status === 'loading') + '">' + rows + hint + err + '<p class="atl-price__note">' + esc(T('price.note')) + '</p></div>';
  };

  /* ---------- récapitulatif latéral ---------- */
  function renderSummary() {
    var body = $('[data-role="sum-body"]'), badge = $('[data-role="sum-badge"]');
    if (!body) return;
    var infos = A.infos(), ls = localSubtotal();
    var html = '';
    if (!infos.length) html += '<p class="atl-muted">' + esc(T('summary.empty')) + '</p>';
    else {
      html += '<ul class="atl-sum__list">' + infos.map(function (i) {
        var meta = [i.colorLabel, i.sizeLabel].filter(Boolean).join(' · ');
        return '<li class="atl-sum__item' + (i.complete ? '' : ' is-incomplete') + '"><img src="' + esc(imgUrl(i.image, 120)) + '" alt="" width="52" height="65" loading="lazy">' +
          '<div><b>' + (infos.length > 1 ? '<span class="atl-sum__n">' + i.n + '</span> ' : '') + esc(i.title) + '</b><span>' + esc(meta || (i.complete ? '' : T('step2.incompleteShort'))) + '</span>' +
          '<span>' + (i.complete ? esc(i.qty + ' × ' + money(i.unit, i.currency)) : '') + '</span>' +
          (S.step >= 3 && A.itemDesignHtml ? A.itemDesignHtml(i) : '') + '</div></li>';
      }).join('') + '</ul>';
      if (ls.count) html += A.priceHtml();
    }
    body.innerHTML = html;
    if (badge) badge.textContent = ls.count ? T('summary.count', { n: ls.count }) + (S.est.data && S.est.data.total !== null ? ' · ' + money(S.est.data.total, S.est.data.currency) : '') : '';
  }
  A.renderSummary = renderSummary;

  /* ---------- navigation ---------- */
  function focusStep() {
    var host = $('[data-role="step"]');
    if (!host) return;
    var h = host.querySelector('.atl-h');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = root.getBoundingClientRect().top + window.pageYOffset - 100;
    if (window.pageYOffset > top || root.getBoundingClientRect().top < 0) window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
  }

  function renderStep(opts) {
    var host = $('[data-role="step"]');
    var st = A.steps[S.step];
    if (!host || !st) return;
    host.innerHTML = '';
    clampTab();
    st.render(host);
    if (st.update) st.update();
    renderProgress(); renderNav(); renderSideCta(); renderSummary(); A.hideNav(false);
    if (!opts || !opts.silent) focusStep();
  }
  A.renderStep = renderStep;

  function go(n, opts) {
    n = Math.max(1, Math.min(STEPS, n));
    if (n > S.step) {
      for (var i = S.step; i < n; i++) {
        var v = A.steps[i] && A.steps[i].validate ? A.steps[i].validate() : { ok: true };
        if (!v.ok) {
          if (i !== S.step) { S.step = i; renderStep({ silent: true }); }
          if (typeof v.tab === 'number' && !S.same) { S.tab = v.tab; renderStep({ silent: true }); }
          A.setNavError(v.msg);
          if (v.focus) { var f = $(v.focus); if (f && f.focus) f.focus(); }
          return false;
        }
      }
    }
    /* en avançant, on repart du premier article (sauf lien « Modifier » d'un article précis) */
    if (n > S.step && !(opts && opts.keepTab)) S.tab = 0;
    S.step = n;
    S.maxStep = Math.max(S.maxStep, n);
    if (!opts || !opts.fromPop) { try { history.pushState({ atl: n }, '', '#atelier-' + n); } catch (e) { /* rien */ } }
    persist();
    renderStep();
    if (n === 2 || n === 5) scheduleEstimate();
    return true;
  }
  A.go = go;
  window.addEventListener('popstate', function (e) {
    var s = e.state && e.state.atl;
    if (s && s !== S.step && s <= S.maxStep) go(s, { fromPop: true });
  });

  A.changed = function (o) {
    o = o || {};
    persist();
    renderProgress(); renderSummary();
    var st = A.steps[S.step];
    if (st && st.update && !o.skipUpdate) st.update();
    if (o.estimate) scheduleEstimate();
  };

  /* ---------- étape 1 : choisir les articles ---------- */
  function catCounts() {
    var c = { all: A.catalog.length };
    A.catalog.forEach(function (p) { c[p.cat] = (c[p.cat] || 0) + 1; });
    return c;
  }
  function visibleProducts() { return A.catalog.filter(function (p) { return S.cat === 'all' || p.cat === S.cat; }); }
  function isSelected(h) { return S.lines.some(function (l) { return l.handle === h; }); }
  function cardHtml(p) {
    var sel = isSelected(p.handle);
    return '<article class="atl-card' + (sel ? ' is-selected' : '') + '" data-handle="' + esc(p.handle) + '">' +
      '<div class="atl-card__tile"><img src="' + esc(imgUrl(p.image, 480)) + '" alt="' + esc(p.imageAlt || p.title) + '" width="480" height="600" loading="lazy">' +
      '<span class="atl-card__check" aria-hidden="true">✓</span></div>' +
      '<div class="atl-card__meta"><h4>' + esc(p.title) + '</h4><div class="atl-card__price">' + esc(T('step1.from', { price: money(p.price, p.currency) })) + '</div></div>' +
      '<button type="button" class="btn ' + (sel ? 'btn--gold' : 'btn--outline') + ' atl-card__btn" data-action="toggle" data-handle="' + esc(p.handle) + '" aria-pressed="' + sel + '">' + esc(sel ? T('step1.added') : T('step1.add')) + '</button>' +
      '</article>';
  }
  function drawCatalog() {
    var chips = $('[data-role="chips"]'), grid = $('[data-role="grid"]');
    if (!chips || !grid) return;
    if (catalogState === 'loading') {
      chips.innerHTML = '';
      grid.innerHTML = '<p class="atl-muted" role="status">' + esc(T('common.loading')) + '</p>';
      return;
    }
    if (catalogState === 'error') {
      chips.innerHTML = '';
      grid.innerHTML = '<div class="atl-empty"><p>' + esc(T('step1.catalogError')) + '</p><button type="button" class="btn btn--outline" data-action="retry-catalog">' + esc(T('common.retry')) + '</button></div>';
      return;
    }
    var counts = catCounts();
    var html = '';
    if (A.catalog.length > 1) {
      html = '<button type="button" class="atl-chip' + (S.cat === 'all' ? ' is-active' : '') + '" data-action="cat" data-cat="all" aria-pressed="' + (S.cat === 'all') + '">' + esc(T('step1.all')) + ' <span>' + counts.all + '</span></button>';
      CATS.forEach(function (c) { if (counts[c]) html += '<button type="button" class="atl-chip' + (S.cat === c ? ' is-active' : '') + '" data-action="cat" data-cat="' + c + '" aria-pressed="' + (S.cat === c) + '">' + esc(T('cat.' + c)) + ' <span>' + counts[c] + '</span></button>'; });
    }
    chips.innerHTML = html;
    var list = visibleProducts();
    grid.innerHTML = list.length ? list.map(cardHtml).join('') : '<p class="atl-muted">' + esc(T('step1.none')) + '</p>';
    var hint = $('[data-role="hint"]');
    if (hint) hint.textContent = S.lines.length ? T('step1.selected', { n: groups().length }) : '';
  }
  function updateCards() {
    $$('.atl-card').forEach(function (card) {
      var sel = isSelected(card.getAttribute('data-handle'));
      card.classList.toggle('is-selected', sel);
      var b = card.querySelector('.atl-card__btn');
      if (b) { b.textContent = sel ? T('step1.added') : T('step1.add'); b.className = 'btn ' + (sel ? 'btn--gold' : 'btn--outline') + ' atl-card__btn'; b.setAttribute('aria-pressed', String(sel)); }
    });
    var hint = $('[data-role="hint"]');
    if (hint) hint.textContent = S.lines.length ? T('step1.selected', { n: groups().length }) : '';
  }

  A.steps[1] = {
    render: function (el) {
      el.innerHTML = '<header class="atl-step__head"><h3 class="atl-h" id="atl-h1">' + esc(T('step1.title')) + '</h3><p class="atl-sub">' + esc(T('step1.sub')) + '</p></header>' +
        '<div class="atl-tools"><div class="atl-chips" role="group" aria-label="' + esc(T('step1.categories')) + '" data-role="chips"></div></div>' +
        '<div class="atl-grid" data-role="grid"></div><p class="atl-hint" data-role="hint" aria-live="polite"></p>';
      drawCatalog();
    },
    update: function () { updateCards(); },
    validate: function () {
      return S.lines.length ? { ok: true } : { ok: false, msg: T('step1.empty'), focus: '.atl-card__btn' };
    }
  };

  /* ---------- étape 2 : taille, couleur, quantité ---------- */
  function swatchHtml(d, line, c) {
    var on = line.color === c.value, en = colorEnabled(d, line, c.value);
    return '<button type="button" class="atl-sw' + (on ? ' is-selected' : '') + '" data-action="color" data-uid="' + line.uid + '" data-value="' + esc(c.value) + '" aria-pressed="' + on + '"' + (en ? '' : ' disabled aria-disabled="true"') + ' title="' + esc(c.label) + '">' +
      '<span class="atl-sw__dot" style="--sw:' + esc(c.hex) + '"></span><span class="atl-sw__name">' + esc(c.label) + '</span></button>';
  }
  function sizeHtml(d, line, s) {
    var on = line.size === s.value, en = sizeEnabled(d, line, s.value);
    return '<button type="button" class="atl-size' + (on ? ' is-selected' : '') + '" data-action="size" data-uid="' + line.uid + '" data-value="' + esc(s.value) + '" aria-pressed="' + on + '"' + (en ? '' : ' disabled aria-disabled="true"') + '>' + esc(s.label) + '</button>';
  }
  function lineHtml(line, idx, total) {
    var d = A.products[line.handle], i = lineInfo(line);
    if (!d) return '<div class="atl-line"><p class="atl-muted">' + esc(T('common.loading')) + '</p></div>';
    var opts = '';
    if (d.colorIdx >= 0 && d.colors.length > 1) {
      opts += '<div class="atl-opt"><span class="atl-opt__label">' + esc(T('opt.color')) + (line.color ? ' : <b>' + esc(i.colorLabel) + '</b>' : '') + '</span><div class="atl-opt__row" role="group" aria-label="' + esc(T('opt.color')) + '">' + d.colors.map(function (c) { return swatchHtml(d, line, c); }).join('') + '</div></div>';
    }
    if (d.sizeIdx >= 0 && d.sizes.length > 1) {
      opts += '<div class="atl-opt"><span class="atl-opt__label">' + esc(T('opt.size')) + (line.size ? ' : <b>' + esc(i.sizeLabel) + '</b>' : '') + '</span><div class="atl-opt__row" role="group" aria-label="' + esc(T('opt.size')) + '">' + d.sizes.map(function (s) { return sizeHtml(d, line, s); }).join('') + '</div></div>';
    } else if (d.sizeIdx >= 0 && d.sizes.length === 1) {
      opts += '<div class="atl-opt"><span class="atl-opt__label">' + esc(T('opt.size')) + ' : <b>' + esc(d.sizes[0].label) + '</b></span></div>';
    }
    if (!opts) opts = '<div class="atl-opt"><span class="atl-opt__label">' + esc(T('opt.single')) + '</span></div>';
    var need = [];
    if (d.colorIdx >= 0 && d.colors.length > 1 && !line.color) need.push(T('step2.chooseColor'));
    if (d.sizeIdx >= 0 && d.sizes.length > 1 && !line.size) need.push(T('step2.chooseSize'));
    var unavailable = !i.complete && !need.length ? T('step2.unavailable') : '';
    var max = C.limits.maxQty;
    return '<div class="atl-line" data-uid="' + line.uid + '">' +
      '<div class="atl-line__img"><img src="' + esc(imgUrl(i.image, 240)) + '" alt="' + esc(d.title + (i.colorLabel ? ' — ' + i.colorLabel : '')) + '" width="120" height="150" loading="lazy"></div>' +
      '<div class="atl-line__main">' + (S.lines.length > 1 ? '<p class="atl-line__n">' + esc(T('line.n', { n: i.n })) + '</p>' : '') + opts + (need.length ? '<p class="atl-line__need" role="status">' + esc(need.join(' · ')) + '</p>' : '') + (unavailable ? '<p class="atl-line__need">' + esc(unavailable) + '</p>' : '') + '</div>' +
      '<div class="atl-line__side">' +
        '<div class="atl-qty" role="group" aria-label="' + esc(T('opt.qty')) + '"><button type="button" class="atl-qty__b" data-action="qty" data-uid="' + line.uid + '" data-d="-1" aria-label="−"' + (line.qty <= 1 ? ' disabled' : '') + '>−</button><output aria-live="polite">' + line.qty + '</output><button type="button" class="atl-qty__b" data-action="qty" data-uid="' + line.uid + '" data-d="1" aria-label="+"' + (line.qty >= max ? ' disabled' : '') + '>+</button></div>' +
        '<div class="atl-line__price"><span>' + (i.complete ? esc(T('price.unit')) + ' ' + esc(money(i.unit, i.currency)) : '') + '</span><b>' + (i.complete ? esc(money(i.total, i.currency)) : '—') + '</b></div>' +
        (total > 1 ? '<button type="button" class="atl-link" data-action="remove-line" data-uid="' + line.uid + '">' + esc(T('common.remove')) + '</button>' : '') +
      '</div></div>';
  }
  function groupHtml(g) {
    var d = A.products[g.handle], p = productByHandle(g.handle);
    var first = lineInfo(g.lines[0]);
    var multi = d && d.variants.length > 1;
    return '<section class="atl-prod" data-handle="' + esc(g.handle) + '"><header class="atl-prod__head"><img src="' + esc(imgUrl(first.image, 160)) + '" alt="" width="64" height="80" loading="lazy">' +
      '<div><h4>' + esc(d ? d.title : (p ? p.title : g.handle)) + '</h4><span class="atl-prod__cat">' + esc(p ? T('cat.' + p.cat) : '') + '</span></div>' +
      '<button type="button" class="atl-link" data-action="remove-product" data-handle="' + esc(g.handle) + '">' + esc(T('step2.removeItem')) + '</button></header>' +
      '<div class="atl-lines">' + g.lines.map(function (l, idx) { return lineHtml(l, idx, g.lines.length); }).join('') + '</div>' +
      (multi ? '<button type="button" class="atl-addline" data-action="add-line" data-handle="' + esc(g.handle) + '">+ ' + esc(T('step2.addLine')) + '</button>' : '') + '</section>';
  }
  function drawLines() {
    var host = $('[data-role="lines"]');
    if (!host) return;
    var scroll = window.pageYOffset;
    host.innerHTML = groups().map(groupHtml).join('') || '<p class="atl-muted">' + esc(T('summary.empty')) + '</p>';
    window.scrollTo(0, scroll);
  }
  A.steps[2] = {
    render: function (el) {
      el.innerHTML = '<header class="atl-step__head"><h3 class="atl-h" id="atl-h2">' + esc(T('step2.title')) + '</h3><p class="atl-sub">' + esc(T('step2.sub')) + '</p></header><div data-role="lines"></div>' +
        '<p class="atl-note"><span aria-hidden="true">ⓘ</span> ' + esc(T('step2.perArticle')) + '</p>';
      drawLines();
    },
    update: function () { },
    updatePrice: function () { },
    validate: function () {
      var bad = A.infos().filter(function (i) { return !i.complete; })[0];
      if (!S.lines.length) return { ok: false, msg: T('step1.empty') };
      return bad ? { ok: false, msg: T('step2.incomplete'), focus: '.atl-line__need' } : { ok: true };
    }
  };

  /* ---------- événements ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-action]');
    if (!b || !root.contains(b)) return;
    var act = b.getAttribute('data-action');
    if (act === 'notice-close') { A.notice(''); return; }
    if (act === 'goto') {
      var tab = b.getAttribute('data-tab'), keep = false;
      if (tab !== null && tab !== '') { S.tab = Math.max(0, parseInt(tab, 10) || 0); keep = true; }   /* l'onglet demandé reste affiché */
      go(parseInt(b.getAttribute('data-step'), 10), { keepTab: keep }); return;
    }
    if (act === 'back') { go(S.step - 1); return; }
    if (act === 'next') { go(S.step + 1); return; }
    if (act === 'cat') { S.cat = b.getAttribute('data-cat'); drawCatalog(); return; }
    if (act === 'retry-catalog') { loadCatalog(); return; }
    if (act === 'toggle') {
      var h = b.getAttribute('data-handle');
      if (isSelected(h)) { removeProduct(h); A.changed({ estimate: true }); return; }
      b.disabled = true; b.textContent = '…';
      addProduct(h).then(function () { A.changed({ estimate: true }); }).catch(function () { A.notice(T('step1.addError'), 'error'); }).then(function () { b.disabled = false; });
      return;
    }
    if (act === 'remove-product') { removeProduct(b.getAttribute('data-handle')); drawLines(); A.changed({ estimate: true, skipUpdate: true }); if (!S.lines.length) go(1); return; }
    if (act === 'add-line') {
      var hh = b.getAttribute('data-handle'), g = groups().filter(function (x) { return x.handle === hh; })[0];
      var last = g ? g.lines[g.lines.length - 1] : null;
      var nl = blankLine(hh); nl.color = last ? last.color : null;
      S.lines.push(nl); normalizeLine(nl); drawLines(); A.changed({ estimate: true, skipUpdate: true }); return;
    }
    var line = lineByUid(b.getAttribute('data-uid'));
    if (!line) return;
    if (act === 'color') { line.color = b.getAttribute('data-value'); normalizeLine(line); drawLines(); A.changed({ estimate: true, skipUpdate: true }); return; }
    if (act === 'size') { line.size = b.getAttribute('data-value'); normalizeLine(line); drawLines(); A.changed({ estimate: true, skipUpdate: true }); return; }
    if (act === 'qty') { line.qty = Math.max(1, Math.min(C.limits.maxQty, line.qty + parseInt(b.getAttribute('data-d'), 10))); drawLines(); A.changed({ estimate: true, skipUpdate: true }); return; }
    if (act === 'remove-line') { S.lines = S.lines.filter(function (l) { return l.uid !== line.uid; }); clampTab(); A.gcImages(); drawLines(); A.changed({ estimate: true, skipUpdate: true }); return; }
  });

  /* ---------- démarrage ---------- */
  function loadCatalog() {
    catalogState = 'loading';
    if (S.step === 1) drawCatalog();
    return A.data.fetchCatalog().then(function (list) {
      var order = {}; CATS.forEach(function (c, i) { order[c] = i; });
      list.sort(function (a, b) { return ((order[a.cat] === undefined ? 99 : order[a.cat]) - (order[b.cat] === undefined ? 99 : order[b.cat])) || a.title.localeCompare(b.title, C.lang); });
      A.catalog = list; catalogState = list.length ? 'ok' : 'error';
    }).catch(function () { catalogState = 'error'; }).then(function () { if (S.step === 1) { drawCatalog(); updateCards(); } });
  }

  /* l'en-tête du thème n'est pas toujours « collant » : on mesure pour que le récapitulatif ne passe jamais dessous */
  function syncTop() {
    var h = document.querySelector('.pb-header, .hdr'), top = 0;
    if (h) {
      /* c'est le conteneur du groupe de sections « en-tête » qui est collant, pas l'en-tête lui-même */
      var w = h.closest('.shopify-section-group-header-group') || h, r = w.getBoundingClientRect(), pos = getComputedStyle(w).position;
      if (r.bottom > 0 && (pos === 'sticky' || pos === 'fixed')) top = Math.round(r.bottom);
    }
    root.style.setProperty('--atl-top', top + 'px');
  }
  var syncTimer;
  window.addEventListener('scroll', function () { clearTimeout(syncTimer); syncTimer = setTimeout(syncTop, 80); }, { passive: true });
  window.addEventListener('resize', syncTop);

  /* une page produit « standard » renvoie vers l'Atelier avec ?product=<article du site>&variant=<variante du site> :
     on retrouve l'article personnalisable jumeau (étiquette atelier_ref) et la variante équivalente */
  function twinFor(handle) {
    for (var i = 0; i < A.catalog.length; i++) if (A.catalog[i].handle === handle || A.catalog[i].refHandle === handle) return A.catalog[i];
    return null;
  }

  function start() {
    shell();
    syncTop();
    var restored = restore();
    var arrived = false;
    loadCatalog().then(function () {
      var params = new URLSearchParams(window.location.search);
      var pre = params.get('product'), preVariant = params.get('variant');
      var twin = pre ? twinFor(pre) : null;
      var chain = Promise.resolve();
      if (restored) {
        chain = ensureProducts().then(function () {
          if (!S.lines.length) { S.step = 1; S.maxStep = 1; return; }
          /* un article dont le choix n'est plus valable (rupture, autre langue) ramène à l'étape 2 */
          if (S.step > 2 && A.infos().some(function (i) { return !i.complete; })) { S.step = 2; S.maxStep = Math.min(S.maxStep, 2); }
          A.notice(T('restore.notice'), 'info');
        });
      }
      if (twin && !isSelected(twin.handle)) {
        chain = chain.then(function () { return addProduct(twin.handle, preVariant); }).then(function () {
          if (S.step === 1) { S.step = 2; S.maxStep = Math.max(S.maxStep, 2); }
          arrived = true;
          A.notice(T('preselect.notice'), 'info');
        }).catch(function () { /* produit introuvable : on reste à l'étape 1 */ });
      } else if (pre && !twin) {
        chain = chain.then(function () { A.notice(T('preselect.unavailable'), 'error'); });
      }
      return chain;
    }).then(function () {
      var st = A.steps[S.step] ? S.step : 1;
      S.step = st;
      renderStep({ silent: true });
      try { history.replaceState({ atl: S.step }, '', window.location.pathname + window.location.search + (S.step > 1 ? '#atelier-' + S.step : (/^#atelier-\d$/.test(window.location.hash) ? '' : window.location.hash))); } catch (e) { /* rien */ }
      if (S.lines.length) scheduleEstimate();
      if (arrived) setTimeout(function () { window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.pageYOffset - 16), behavior: 'auto' }); }, 120);
      A.ready = true;
      document.dispatchEvent(new CustomEvent('ptb-atelier-ready'));
    });
  }

  A.restartAll = function () {
    A.clearStored();
    S.step = 1; S.maxStep = 1; S.lines = []; S.same = true; S.tab = 0; S.consent = false; S.est = { status: 'idle', data: null };
    A.images = {};
    A.notice('');
    renderStep();
  };

  /* le service d'envoi (ou le mode aperçu) décide si l'assistant est affiché : voir la section Liquid */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
